/**
 * Owner: Masa Bayu
 * File: HomeScreen.tsx
 * Date:Time: 2026-10-18 12:30
 * Description: Home Screen — landing §376 replika 100% mockup (mobile gold
 *   standard + desktop dashboard). Senarai penuras lama pindah ke /all-books.
 */

import type { ReactElement } from 'react';
import { LandingHome } from './marketplace/landing/LandingHome';

export interface HomeScreenProps {
  readonly chromeMode: string;
  readonly onNavigate: (path: string) => void;
}

export function HomeScreen({ chromeMode, onNavigate }: HomeScreenProps): ReactElement {
  return (
    <div
      className="home-screen qx-motion-page-enter"
      data-chrome-mode={chromeMode}
      data-home-layout="landing"
    >
      <LandingHome onNavigate={onNavigate} />
      {!import.meta.env.DEV ? null : (
        <p className="route-panel__meta" role="status">
          Chrome mode: {chromeMode} · Session ≠ entitlement
        </p>
      )}
    </div>
  );
}
